import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.623 2.253l-.609 3.583C.91 6.446 1.39 7 2.021 7h.91c.58 0 1.11-.321 1.37-.83L4.897 5l.597 1.17c.26.509.79.83 1.37.83h1.169c.58 0 1.11-.321 1.369-.83L10 5l.597 1.17c.26.509.79.83 1.37.83h1.169c.58 0 1.11-.321 1.369-.83L15.102 5l.598 1.17c.259.509.789.83 1.369.83h.91c.63 0 1.11-.555 1.007-1.164l-.61-3.583A1.522 1.522 0 0 0 16.867 1H3.134c-.748 0-1.387.53-1.51 1.253zm12.084 7.04a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 12.586l3.293-3.293a1 1 0 0 1 1.414 0zM4 9H2v8.5A1.5 1.5 0 0 0 3.5 19h13a1.5 1.5 0 0 0 1.5-1.5V9h-2v8H4V9z"
});

var SvgManagedStoreMajor = function SvgManagedStoreMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgManagedStoreMajor as S };
